module.exports = __webpack_public_path__ + "static/media/wm_bg_learn.908b6241.webp";